module.exports = __webpack_public_path__ + "img/DSC_2793.13e355dc.png";